export let aprilAbbreviatedLowercase = "koKWWb";
export default {aprilAbbreviatedLowercase};